export default {
  //Orange
  MCHI_DARK_ORANGE: "#e35205",
  MCHI_LOGO_ORANGE: "#f68621",
  MCHI_LIGHT_ORANGE: "#f1b434",
  MCHI_BORDER_COLOR: "#f37020",
  //Blue
  MCHI_LIGHT_BLUE: "#00a9e0",
  MCHI_LOGO_BLUE: "#188ccc",
  MCHI_DARK_BLUE: "#004986",
  //Green
  MCHI_LIGHT_GREEN: "#c4d600",
  MCHI_LOGO_GREEN: "#39b54a",
  MCHI_DARK_GREEN: "#007a3e",
  WHITE: "#ffffff",

  MCHI_CONTAINER_BACKGROUND: "#ebfaff",
  MCHI_BACKGROUND_GREY: "#f1f1f1",
  ERROR_BACKGROUND: "#157cb3",

  MCHI_GRADIENT_START: "#0184c9",
  MCHI_GRADIENT_END: "#004779",

  MCHI_GRADIENT_ORANGE_START: "#f26221",
  MCHI_GRADIENT_ORANGE_END: "#f5851f",

  GREY: "#e7e7e7",
  DARK_GREY: "#b3b3b3",
  BLACK: "#111111",
};
